module.exports = __webpack_public_path__ + "img/hx-zdhjc-w.b5cbdbbe.svg";